/**
 * Small shared pieces of the e-signature field editor and its read-only
 * summary: the colour each field is drawn in and how a field's placement is
 * described.
 *
 * Copied from corp-dashboard/lib/esign/fields.ts.
 */

import { keywordIsFreePlaced, pageNumberOf } from './geometry';
import { phpTrim } from './match';

/** One colour per field, in list order (the legacy editor's palette). */
export const FIELD_COLOURS = ['#1f6fd0', '#c2185b', '#2e7d32', '#ef6c00', '#6a1b9a', '#00838f', '#5d4037', '#455a64'] as const;

export function fieldColour(index: number): string {
  return FIELD_COLOURS[((index % FIELD_COLOURS.length) + FIELD_COLOURS.length) % FIELD_COLOURS.length];
}

/** rgba() of a #rrggbb colour. */
export function colourAlpha(hex: string, alpha: number): string {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex);
  if (!m) return hex;
  return `rgba(${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)},${alpha})`;
}

export type FieldPlacementSummary = { kind: 'words'; words: string } | { kind: 'fixed'; page: number } | { kind: 'missing' };

export function describePlacement(tabKeywords: string, signaturePageNum: string): FieldPlacementSummary {
  if (keywordIsFreePlaced(tabKeywords, signaturePageNum)) {
    return { kind: 'fixed', page: pageNumberOf(signaturePageNum) };
  }
  const words = phpTrim(tabKeywords);
  return words === '' ? { kind: 'missing' } : { kind: 'words', words };
}
